export default __webpack_public_path__ + "static/franchise-7-6a854b714809e1ff6cba6a3d35bd583b.jpg";